// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  position: relative;
}
:host input.input-search {
  caret-color: black;
  margin-bottom: 15px;
}
:host input.input-search.blocked {
  opacity: 0.8;
  pointer-events: none;
}
:host .highlighted {
  background-color: #dbedff;
}
:host .dropdown-menu {
  margin-top: 0;
  margin-left: 10px;
  height: 300px;
  overflow-y: auto;
  min-width: 300px;
  z-index: 99999;
  position: relative;
  display: block;
  margin-left: 0;
  position: absolute;
  bottom: 0;
  left: 0;
  max-width: 500px;
}
:host .dropdown-menu .dropdown-label {
  text-transform: uppercase;
  padding: 7px 23px 10px;
  font-size: 14px;
}
:host .dropdown-menu .dropdown-label.system {
  padding: 12px 23px 12px;
  border-top: 1px solid lightgray;
  border-bottom: 1px solid lightgray;
}
:host .dropdown-menu .users-empty {
  padding: 0 20px 15px;
  width: 100%;
  text-align: center;
  font-size: 14px;
}
:host .dropdown-menu .users-empty.system {
  padding-top: 15px;
}
:host .dropdown-menu .dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 61px;
  position: relative;
  z-index: 100000;
}
:host .dropdown-menu .dropdown-item:active {
  background: white;
}
:host .dropdown-menu .dropdown-item .user-thumbnail {
  width: 50px;
  min-width: 50px;
  height: 50px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
:host .dropdown-menu .dropdown-item:hover {
  cursor: pointer;
}
:host .dropdown-menu .dropdown-item .info-cont .days,
:host .dropdown-menu .dropdown-item .info-cont .user-add-info {
  font-size: 13px;
  color: #ff005a;
  font-weight: 600;
  margin-top: 2px;
}
:host .label-container,
:host .field-container {
  padding: 10px;
}
:host .label-container {
  flex: 1;
  max-width: 200px;
  text-align: right;
  font-size: 14px;
  padding-top: 15px;
}
:host .artists-container .field-container {
  flex: 3;
  max-width: 500px;
  font-size: 14px;
  position: relative;
}
:host .artists-container .field-container.selected-admin-row {
  display: flex;
  justify-content: flex-start;
  gap: 15px;
  align-items: center;
}
:host .artists-container .field-container.selected-admin-row .thumbnail-img {
  width: 60px;
}
:host .artists-container .field-container.selected-admin-row .icon-close {
  position: absolute;
  top: 5px;
  right: 0;
  width: 16px;
  margin: 10px;
}
:host .artists-container .field-container.selected-admin-row .icon-close:hover {
  cursor: pointer;
}
:host .artists-container .field-container.selected-admin-row .admin-thumbnail {
  width: 50px;
  height: 50px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
:host .artists-container .field-container.selected-admin-row .admin-name span {
  display: block;
  margin-bottom: 5px;
}
:host .artists-container.small-chips {
  position: relative;
  top: -5px;
}
:host .artists-container.small-chips .small-chips-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
:host .artists-container.small-chips .small-chips-row .small-chip {
  display: inline-block;
  position: relative;
  padding-right: 20px;
  border: 1px solid grey;
  font-size: 13px;
  border-radius: 12px;
  padding: 4px 25px 4px 10px;
  background: white;
}
:host .artists-container.small-chips .small-chips-row .small-chip img.icon-close {
  position: absolute;
  width: 10px;
  top: 1px;
  bottom: 0;
  right: 7px;
  margin: auto;
  height: 10px;
}
:host .artists-container.small-chips .small-chips-row .small-chip img.icon-close:hover {
  cursor: pointer;
  opacity: 0.65;
}
:host .input-cont {
  position: relative;
}
:host .input-cont.dropdown-up .dropdown-menu {
  bottom: auto;
  top: -300px;
  display: flex;
  flex-direction: column-reverse;
}
:host .input-cont.dropdown-up .dropdown-menu .dropdown-menu-section {
  display: flex;
  flex-direction: column-reverse;
}
:host .input-cont .inline-user {
  display: flex;
  align-items: center;
  gap: 3px;
  margin-right: 10px;
}
:host .input-cont .inline-user .user-name {
  font-size: 13px;
  white-space: nowrap;
  pointer-events: all;
}
:host .input-cont .inline-user img.remove-user {
  width: 10px;
  height: 10px;
  pointer-events: all;
}
:host .input-cont .inline-user img.remove-user:hover {
  cursor: pointer;
}
:host .input-cont .inline-user img.remove-user:hover:hover {
  opacity: 0.65;
}

.selected-input-users {
  position: absolute;
  top: 0;
  height: 63px;
  max-width: 400px;
  width: 400px;
  pointer-events: none;
  display: block;
}

.selected-input-users-in {
  display: flex;
  gap: 9px;
  padding-left: 100px;
  height: 33px;
  width: calc(100% - 10px);
  white-space: nowrap;
  overflow-x: hidden;
  padding-right: 20px;
}
.selected-input-users-in .added-artists-counter {
  position: absolute;
  right: 3px;
  width: 27px;
  height: 27px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 4px;
  border: 1px solid #ced4da;
  border-radius: 3px;
  font-size: 13px;
  pointer-events: all;
}
.selected-input-users-in .added-artists-counter:hover .list-of-artists {
  display: flex;
}
.selected-input-users-in .added-artists-counter .list-of-artists-out {
  position: absolute;
  top: 10px;
  right: -3px;
}
.selected-input-users-in .added-artists-counter .list-of-artists {
  display: none;
  margin-top: 20px;
  padding: 10px 15px;
  background: white;
  border-radius: 3px;
  z-index: 9;
  border: 1px solid #ced4da;
  width: 150px;
  gap: 10px;
  flex-direction: column;
}
.selected-input-users-in .added-artists-counter .list-of-artists .inline-user {
  display: flex;
  align-items: center;
  gap: 3px;
  margin-right: 0;
  justify-content: space-between;
}
.selected-input-users-in .added-artists-counter .list-of-artists .inline-user .user-name {
  pointer-events: all;
  overflow: hidden;
  text-overflow: ellipsis;
}

.custom-scrollbar {
  position: absolute;
  top: 35px; /* Adjust based on design */
  width: 100%;
  height: 8px;
  background-color: transparent;
  display: none; /* Initially hidden, shown when needed */
  overflow: hidden;
  pointer-events: all;
  height: 18px;
  overflow-x: auto;
}

.scrollbar-thumb {
  width: 50%; /* Set initially to a placeholder value, this will adjust dynamically */
  height: 100%;
  background-color: #b0c4de;
  border-radius: 10px;
  background-clip: content-box;
  border: 4px solid transparent;
  white-space: nowrap;
  padding-right: 20px;
}

.scrollbar-thumb:hover {
  background-color: #8fa8c0;
}

.inline-user {
  display: flex;
  align-items: center;
  gap: 3px;
  margin-right: 10px;
}

.inline-user .user-name {
  font-size: 13px;
  white-space: nowrap;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
